import { render, staticRenderFns } from "./AnswerList.vue?vue&type=template&id=276a15c2&scoped=true"
import script from "./AnswerList.vue?vue&type=script&lang=js"
export * from "./AnswerList.vue?vue&type=script&lang=js"
import style0 from "./AnswerList.vue?vue&type=style&index=0&id=276a15c2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a15c2",
  null
  
)

export default component.exports